// features/configuration.fields.js

export const configurationFields = [
  {
    name:                 "sendgrid_credential_fid",
    label:                "Linked Credential",
    type:                 "select",
    required:             true,
    fullWidth:            true,
    is_api_data:          true,
    optionsKey:           "credentials",
    optionLabel:          "api_key",
    optionLabelFormatter: (opt) =>
      `#SGC${String(opt.id).padStart(3, "0")} — ••••${opt.api_key?.slice(-8) || ""}`,
  },
  {
    name:     "from_email",
    label:    "From Email",
    type:     "email",
    required: true,
  },
  {
    name:     "from_name",
    label:    "From Name",
    type:     "text",
    required: false,
  },
  {
    name:     "reply_to_email",
    label:    "Reply-To Email",
    type:     "email",
    required: false,
  },
  {
    name:     "sending_domain",
    label:    "Sending Domain",
    type:     "text",
    required: false,
  },
  {
    name:          "mailing_for",
    label:         "Mailing For",
    type:          "select",
    required:      false,
    is_enums_data: true,
    enums:         ["NOTIFICATIONS", "MARKETING"],
  },
  {
    name:         "is_activated",
    label:        "Active",
    type:         "boolean",
    defaultValue: true,
  },
];
